import { render } from "./DialogCallback.vue?vue&type=template&id=85b9d5ae&scoped=true"
import script from "./DialogCallback.vue?vue&type=script&lang=js"
export * from "./DialogCallback.vue?vue&type=script&lang=js"

import "./DialogCallback.vue?vue&type=style&index=0&id=85b9d5ae&scoped=true&lang=css"

import exportComponent from "/Users/nikita/Documents/works/novofamil/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85b9d5ae"]])

export default __exports__